/**
 * i18n bootstrap for the identity-app SPA (METS-18925 EN/FR migration copy).
 */

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enMigration from "./locales/en/migration.json";
import frMigration from "./locales/fr/migration.json";

const LANGUAGE_STORAGE_KEY = "sovra.identity.lang";

export function detectLanguage(): string {
  const stored = sessionStorage.getItem(LANGUAGE_STORAGE_KEY);
  if (stored === "en" || stored === "fr") {
    return stored;
  }
  const params = new URLSearchParams(window.location.search);
  const fromQuery = params.get("ui_locales") || params.get("lang");
  if (fromQuery) {
    // Remember the requested language so a later Auth0 return without ui_locales
    // does not fall through to the browser language.
    const lang = fromQuery.toLowerCase().startsWith("fr") ? "fr" : "en";
    sessionStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
    return lang;
  }
  if (navigator.language?.toLowerCase().startsWith("fr")) {
    return "fr";
  }
  return "en";
}

void i18n.use(initReactI18next).init({
  resources: {
    en: { migration: enMigration },
    fr: { migration: frMigration },
  },
  lng: detectLanguage(),
  fallbackLng: "en",
  defaultNS: "migration",
  ns: ["migration"],
  interpolation: { escapeValue: false },
});

export function setAppLanguage(lang: "en" | "fr"): void {
  sessionStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
  void i18n.changeLanguage(lang);
}

export default i18n;
